import React from "react";
import { notificationTypes } from "@/store/slices/notifications/types";
import * as styles from "./style.module.scss";
import Typography from "@mui/material/Typography";
import { unicodeToEmojiV2 } from "@/services/generic.methods";

const NestedMessage = ({ notification }) => {
  return (
    <Typography className={styles?.notificationSubText}>
      {notification?.message?.sender?.name && (
        <Typography
          component={"span"}
          className={styles?.notificationSubTextHeading}
        >
          {" "}
          {(notification?.type === notificationTypes.leads.sms ||
            notification?.type === notificationTypes.leads.emailReceived) &&
            `${notification?.message?.sender?.name}: `}
        </Typography>
      )}
      <span
        dangerouslySetInnerHTML={{
          __html: unicodeToEmojiV2(notification?.message.text),
        }}
      />
    </Typography>
  );
};

export default NestedMessage;
